document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('km').style.display = 'none';

  const lastTabLink = document.querySelector('ul.course_tab_nav > li:last-child > a.realtab');
  const lastTabSpan = lastTabLink.querySelector('span');

  lastTabLink.classList.add('inactive');
  lastTabSpan.classList.add('inactive');
});

export function fullCourse() {
  const firstTabLink = document.querySelector('ul.course_tab_nav > li:first-child > a.realtab');
  const firstTabSpan = firstTabLink.querySelector('span');
  const lastTabLink = document.querySelector('ul.course_tab_nav > li:last-child > a.realtab');
  const lastTabSpan = lastTabLink.querySelector('span');

  lastTabLink.classList.add('inactive');
  lastTabSpan.classList.add('inactive');
  firstTabLink.classList.remove('inactive');
  firstTabSpan.classList.remove('inactive');

  document.getElementById('km').style.display = 'none';
  document.getElementById('full').style.display = 'block';
}

export function kmCourse() {
  const firstTabLink = document.querySelector('ul.course_tab_nav > li:first-child > a.realtab');
  const firstTabSpan = firstTabLink.querySelector('span');
  const lastTabLink = document.querySelector('ul.course_tab_nav > li:last-child > a.realtab');
  const lastTabSpan = lastTabLink.querySelector('span');

  lastTabLink.classList.remove('inactive');
  lastTabSpan.classList.remove('inactive');
  firstTabLink.classList.add('inactive');
  firstTabSpan.classList.add('inactive');

  document.getElementById('km').style.display = 'block';
  document.getElementById('full').style.display = 'none';
}

window.fullCourse = fullCourse;
window.kmCourse = kmCourse;
